import { IApplicationState } from '../../types/redux';

export function getDeveloperRatingById(state: IApplicationState, id: number) {
  const rating = state.developer.ratings.find(rating => rating.id === id);

  return rating || null;
}
